import React from 'react';

class FullscreenButton extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.toggleFullscreen();
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.isFullscreen !== this.props.isFullscreen;
  }

  render() {
    let classes = 'b-fullscreen-button';
    if (this.props.isFullscreen) {
      classes += ' fullscreen';
    }
    return <div className={classes} onClick={this.onClick}></div>;
  }
}

export default FullscreenButton;
